import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@material-ui/icons/Delete';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import IconButton from '~/components/Button/IconButton';

import useStyles from './styles';

function InputDropzoneFile(props) {
  const { onChange, disabled, accept, multiple } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => console.log('file reading has failed');


    acceptedFiles.map((file) => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
      console.log(file.preview);
    })
    setFiles((prev) => [...prev, ...acceptedFiles]);
    onChange((prev) => [...prev, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    multiple,
  });

  function isFileImage(file) {
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    return file && acceptedImageTypes.includes(file['type'])
  }
  return (
    <section className="container">
      <div
        disabled={disabled}
        style={{
          borderRadius: 5,
          backgroundColor: '#efefef',
          padding: 10,
          borderWidth: 1,
          borderColor: '#e3e3e3',
        }}
        {...getRootProps()}
      >
        <input disabled={disabled} hidden={disabled} {...getInputProps()} />
        <p style={{ textAlign: 'center' }}>{t('dropzone_file_placeholder')}</p>
      </div>
      {files &&
        files.map((file) => (
          <GridContainer key={file.name} direction="row" alignItems="center">
            {isFileImage(file) && <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
              <div className={classes.thumb}>
                <div className={classes.thumbInner}>
                  <img src={file.preview} className={classes.img} />
                </div>
              </div>
            </GridItem>}
            <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
              {file.path}
              <IconButton
                tooltip={t('action.remove')}
                onClick={() => {
                  const newFiles = files.filter((item) => item !== file);
                  setFiles(newFiles);
                  onChange(newFiles);
                }}
                Icon={DeleteIcon}
                iconColor="red"
              />
            </GridItem>
          </GridContainer>
        ))}
    </section>
  );
}

export default InputDropzoneFile;
